import { Configuration, PublicClientApplication } from '@azure/msal-browser';

const AUTH_CLIENT_ID: string = import.meta.env.VITE_AUTH_CLIENT_ID || 'NOT_SET';
const AUTH_AUTHORITY_URL: string = import.meta.env.VITE_AUTH_AUTHORITY_URL || 'NOT_SET';

// Popup-based flows (loginPopup/logoutPopup) rely on this page calling
// broadcastResponseToMainFrame() to report back to the opener and close the
// popup; without it, COOP headers from Entra ID prevent the popup from
// closing itself. See redirect.html.
const REDIRECT_BRIDGE_URI = `${location.origin}/redirect.html`;

// MSAL configuration
const configuration: Configuration = {
  auth: {
    clientId: AUTH_CLIENT_ID,
    authority: AUTH_AUTHORITY_URL,
    redirectUri: REDIRECT_BRIDGE_URI,
    postLogoutRedirectUri: REDIRECT_BRIDGE_URI,
  },
};

const msalInstance = new PublicClientApplication(configuration);

export default msalInstance;
